import { render, staticRenderFns } from "./platformGoodsDetail.vue?vue&type=template&id=f7e15258&scoped=true"
import script from "./platformGoodsDetail.vue?vue&type=script&lang=js"
export * from "./platformGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./platformGoodsDetail.vue?vue&type=style&index=0&id=f7e15258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e15258",
  null
  
)

export default component.exports